<template>

  <vue-chosen
    v-model="selectedItems"
    :name="name"
    :options="options"
    :multiple="true"
    :placeholder="placeholder"
  ></vue-chosen>

</template>

<script>
import { mapActions } from 'pinia'
import { useCitizensTrackingStore } from "../../stores/citizensTracking"

export default {

  emits: ['update:modelValue'],

  props: {

    modelValue: {
      type: [String, Number, Array, Object],
      default: '',
    },

    options: {
      type: [Array, Object],
      default: () => {return []}
    },

    name: {
      type: String,
      required: true
    },

    placeholder: {
      type: String,
      default: null
    },
  },

  data: function () {
    return {
      selectedItems: this.modelValue,
    }
  },

  methods: {
    ...mapActions(useCitizensTrackingStore, ['setFilterSelectedClients'])
  },

  watch: {
    selectedItems: {
      deep: true,
      handler (value) {
        this.$emit('update:modelValue', value);
        this.setFilterSelectedClients(value);
      }
    },
  },

  created() {
    this.setFilterSelectedClients(this.modelValue);
  }

}
</script>
